import { Link } from 'react-router-dom';
import styled from 'styled-components';

export const Field = styled.div`
  margin-bottom: 25px;
  text-align: left;
`;

export const Box = styled.div`
  padding: 0 32px;
  height: calc(100vh - 180px);
  overflow: auto;
  border-radius: 16px;
  max-width: 424px;
  text-align: center;
  margin: 0 auto;
`;

export const InputBox = styled.div`
  display: flex;
  align-items: center;
  &:not(:last-of-type) {
    margin-bottom: 16px;
  }
  * {
    font-size: 12px;
  }
`;

export const InputLabel = styled.label`
  text-align: right;
  margin-right: 12px;
  font-size: 12px;
  flex: 1;
  color: ${(props) => props.theme.colors['neutral-80']};
`;

export const InputArea = styled.div`
  flex: 1;
  position: relative;
`;

export const DoubleInputRow = styled.div`
  display: flex;
  font-size: 14px;
  line-height: 150%;
  color: ${(props) => props.theme.colors['neutral-80']};
  margin-bottom: 20px;

  input {
    flex: 1;
  }

  span {
    position: relative;
    top: 25px;
  }

  @media screen and (min-width: ${({ theme }) => theme.breakpoints.md}) {
    width: 100%;
  }
`;

export const Title = styled.p`
  font-size: 18px;
  font-weight: 600;
  color: ${(props) => props.theme.colors['primary-60']};
`;

export const PageHeader = styled.div`
  margin: 34px auto 32px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

export const PartnerName = styled.p`
  font-size: 14px;
  line-height: 150%;
  color: ${(props) => props.theme.colors['neutral-100']};
`;

export const Footer = styled.div`
  align-items: center;
  justify-content: center;
  margin-top: 48px;
  button {
    margin: 5px;
    padding: 0 25px;
    height: 32px;
    display: inline;
  }
`;

export const GoBackLink = styled(Link)`
  color: ${(props) => props.theme.colors['primary-60']};
  font-size: 10px;
  font-weight: 400;
  display: inline-flex;
  align-items: center;
`;
